import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Alert, Button, CircularProgress } from "@mui/material";
import { useCallback, useState } from "react";

import { exportManagementAllRequestList } from "../../../../../infrastructure/api/managementDashboard";
import { drillDownParamsToApiQuery } from "../all-request/allRequestDrillDownUtils";

const FilteredRequestExportButton = ({ listParams, disabled = false }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await exportManagementAllRequestList(drillDownParamsToApiQuery(listParams || {}));
      if (res?.isSuccess === false) {
        setError(res?.message || "خروجی اکسل ناموفق بود.");
        return;
      }
      const link = res?.data?.link || res?.data?.Link;
      if (link) {
        window.open(link, "_blank", "noopener,noreferrer");
      } else {
        setError("لینک خروجی از سرور دریافت نشد.");
      }
    } catch {
      setError("خطا در ارتباط با سرور هنگام خروجی اکسل.");
    } finally {
      setLoading(false);
    }
  }, [listParams]);

  return (
    <>
      <Button
        variant="outlined"
        startIcon={loading ? <CircularProgress size={16} /> : <FileDownloadIcon />}
        onClick={handleExport}
        disabled={disabled || loading}
      >
        خروجی اکسل (فیلتر فعال)
      </Button>
      {error ? (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      ) : null}
    </>
  );
};

export default FilteredRequestExportButton;
